import React, { useState, useEffect, useRef } from 'react';
// !! IMPORTANTE: Substitua estas imagens por capturas de tela do seu sistema escolar !!
import logoSrc from './assets/logo.png'; // Crie um logo adequado
import appScreen1 from './assets/login.jpeg';
import appScreen2 from './assets/nota.jpeg';
import appScreen3 from './assets/faltas.jpeg';
import appScreen4 from './assets/horarios.jpeg';
import appScreen5 from './assets/contacto.jpeg';

// --- Textos para Tradução ---
// Mantidos da versão anterior - ajuste se necessário
const translations = {
  pt: {
    appName: "SIGEP",
    appSlogan: "Gestão Escolar Inteligente e Integrada.",
    navHome: "Início",
    navAbout: "Funcionalidades",
    navContact: "Contato",
    themeToggleLight: "Mudar para tema claro",
    themeToggleDark: "Mudar para tema escuro",
    heroTitle: "SIGEP",
    heroSubtitle: "Simplifique a administração da sua escola.",
    heroDescription: "O SIGEP centraliza inscrições, notas, faltas, horários e comunicação com encarregados em uma plataforma única, eficiente e fácil de usar. Otimize processos e foque no essencial: a educação.",
    heroButton: "Solicitar Demonstração",
    aboutAppTitle: "Conheça as Funcionalidades SIGEP",
    aboutAppDescription: "SIGEP oferece um conjunto completo de ferramentas para modernizar a gestão da sua instituição de ensino:",
    appFeatures: [
      { title: "Inscrições Online Simplificadas", description: "Gerencie todo o processo de matrícula e inscrição de alunos de forma digital, organizada e sem papelada. Facilite a vida dos pais e da secretaria.", imageAlt: "Tela de inscrição online do sistema SIGEP." },
      { title: "Lançamento de Notas e Pautas", description: "Professores lançam notas com agilidade. Geração automática de pautas, boletins e relatórios de desempenho acadêmico personalizáveis.", imageAlt: "Professor lançando notas no sistema SIGEP." },
      { title: "Controle de Presença Eficaz", description: "Registre faltas e presenças de alunos de maneira rápida e integrada. Gere relatórios de assiduidade e notifique encarregados automaticamente.", imageAlt: "Tela de marcação de faltas e controle de presença no SIGEP." },
      { title: "Horários Sempre Acessíveis", description: "Disponibilize os horários de aulas, provas e eventos escolares online para alunos, professores e encarregados. Fácil visualização e atualizações em tempo real.", imageAlt: "Visualização de horário escolar no aplicativo SIGEP." },
      { title: "Comunicação Direta com Encarregados", description: "Canal de comunicação integrado para enviar avisos, comunicados, notas e informações importantes diretamente aos encarregados de educação.", imageAlt: "Interface de comunicação com encarregados no SIGEP." }
    ],
    highlightsTitle: "Vantagens do SIGEP",
    highlight1Title: "Eficiência Administrativa",
    highlight1Desc: "Reduza a carga de trabalho manual, automatize tarefas repetitivas e otimize os processos da secretaria e coordenação.",
    highlight2Title: "Transparência e Acesso",
    highlight2Desc: "Pais e alunos acompanham notas, faltas e horários online, promovendo maior engajamento e transparência.",
    highlight3Title: "Comunicação Integrada",
    highlight3Desc: "Centralize a comunicação escolar, garantindo que informações importantes cheguem a todos de forma rápida e eficaz.",
    screenshotsTitle: "SIGEP em Funcionamento",
    footerAboutCompany: "Sobre a {empresaNome}",
    footerCompanyDesc: "Desenvolvendo soluções inovadoras para a gestão educacional.",
   
    footerAddress: "Endereço",
    footerContact: "Contato",
    footerEmail: "Email",
    footerPhone: "Telefone",
    footerNavigation: "Navegação",
    footerPrivacy: "Política de Privacidade",
    footerTerms: "Termos de Uso",
    footerRights: "© {currentYear} {appName}. Todos os direitos reservados. Raltec Lab.",
  },
  en: {
    appName: "SIGEP",
    appSlogan: "Intelligent and Integrated School Management.",
    navHome: "Home",
    navAbout: "Features",
    navContact: "Contact",
    themeToggleLight: "Switch to light theme",
    themeToggleDark: "Switch to dark theme",
    heroTitle: "SIGEP",
    heroSubtitle: "Simplify your school's administration.",
    heroDescription: "SIGEP centralizes enrollment, grades, attendance, schedules, and communication with guardians in a single, efficient, and easy-to-use platform. Optimize processes and focus on what matters: education.",
    heroButton: "Request a Demo",
    aboutAppTitle: "Explore SIGEP Features",
    aboutAppDescription: "SIGEP offers a complete set of tools to modernize the management of your educational institution:",
     appFeatures: [
      { title: "Simplified Online Enrollment", description: "Manage the entire student registration and enrollment process digitally, organized, and paper-free. Make life easier for parents and the administration.", imageAlt: "Online enrollment screen of the SIGEP system." },
      { title: "Grade Entry and Report Cards", description: "Teachers enter grades quickly. Automatic generation of grade sheets, report cards, and customizable academic performance reports.", imageAlt: "Teacher entering grades in the SIGEP system." },
      { title: "Effective Attendance Control", description: "Record student absences and attendance quickly and integratedly. Generate attendance reports and notify guardians automatically.", imageAlt: "Attendance tracking screen in SIGEP." },
      { title: "Schedules Always Accessible", description: "Make class schedules, exams, and school events available online for students, teachers, and guardians. Easy viewing and real-time updates.", imageAlt: "Viewing school schedule in the SIGEP app." },
      { title: "Direct Communication with Guardians", description: "Integrated communication channel to send notices, announcements, grades, and important information directly to guardians.", imageAlt: "Guardian communication interface in SIGEP." }
    ],
    highlightsTitle: "Advantages of SIGEP",
    highlight1Title: "Administrative Efficiency",
    highlight1Desc: "Reduce manual workload, automate repetitive tasks, and optimize administrative and coordination processes.",
    highlight2Title: "Transparency and Access",
    highlight2Desc: "Parents and students track grades, attendance, and schedules online, promoting greater engagement and transparency.",
    highlight3Title: "Integrated Communication",
    highlight3Desc: "Centralize school communication, ensuring important information reaches everyone quickly and effectively.",
    screenshotsTitle: "SIGEP in Operation",
    footerAboutCompany: "About {empresaNome}",
    footerCompanyDesc: "Developing innovative solutions for educational management.",
  
    footerAddress: "Address",
    footerContact: "Contact",
    footerEmail: "Email",
    footerPhone: "Phone",
    footerNavigation: "Navigation",
    footerPrivacy: "Privacy Policy",
    footerTerms: "Terms of Use",
    footerRights: "© {currentYear} {appName}. All rights reserved. Raltec Lab.",
  }
};

// Estilos Globais e dos Componentes com Tema Azul Suavizado
const GlobalStyles = `
  :root { /* Tema Claro - Azul Suavizado e Branco */
    /* Cores base com azuis suavizados */
    --cor-primaria: #2196F3;    /* Azul Material 500 */
    --cor-secundaria: #64B5F6; /* Azul Material 400 */
    --cor-acentuacao: #42A5F5;  /* Azul Material 600 (antigo secundário) */
    
    --cor-fundo-primario: #ffffff;
    --cor-fundo-secundario: #f8f9fa; 
    --cor-texto-primario: #212529;  
    --cor-texto-secundario: #6c757d; 
    --cor-texto-claro: #ffffff;     
    --cor-borda: #dee2e6;       
    --cor-sombra: rgba(0,0,0,0.08); /* Sombra um pouco mais suave */

    /* Mapeamento Semântico */
    --cor-header-fundo: var(--cor-primaria);
    --cor-header-texto: var(--cor-texto-claro);
    --cor-header-icone: var(--cor-texto-claro);

    --cor-footer-fundo: #212529; /* Footer com fundo quase preto */
    --cor-footer-texto: #ced4da; /* Texto cinza claro no footer */
    --cor-footer-link-hover: var(--cor-secundaria); /* Azul claro no hover */
    --cor-footer-titulo: var(--cor-secundaria); /* Título h4 no footer */

    --cor-hero-titulo: var(--cor-texto-claro);
    --cor-hero-subtitulo: #90CAF9; /* Azul Material 300 */
    --cor-cta-fundo: var(--cor-texto-claro); 
    --cor-cta-texto: var(--cor-primaria); 
    --cor-cta-hover-fundo: #e3f2fd; 

    --cor-highlight-item-fundo: #ffffff;
    --cor-feature-pair-titulo: var(--cor-primaria);
  }

  body.dark-theme { /* Tema Escuro - Tons de Azul Suavizado e Cinza Escuro */
    --cor-primaria: #64B5F6;    /* Azul Claro como primário */
    --cor-secundaria: #2196F3; /* Azul Médio como secundário */
    --cor-acentuacao: #90CAF9;  /* Azul Bem Claro para links/hover */

    --cor-fundo-primario: #1a1f25; 
    --cor-fundo-secundario: #2c333a; 
    --cor-texto-primario: #e9ecef;  
    --cor-texto-secundario: #adb5bd; 
    --cor-texto-claro: #ffffff;     
    --cor-borda: #495057;       
    --cor-sombra: rgba(255,255,255,0.08);

    /* Mapeamento Semântico */
    --cor-header-fundo: #212d38; 
    --cor-header-texto: var(--cor-acentuacao);
    --cor-header-icone: var(--cor-acentuacao);

    --cor-footer-fundo: #11161c; 
    --cor-footer-texto: #ced4da;
    --cor-footer-link-hover: var(--cor-primaria);
    --cor-footer-titulo: var(--cor-primaria); /* Azul claro para título h4 */

    --cor-hero-titulo: var(--cor-texto-claro);
    --cor-hero-subtitulo: var(--cor-acentuacao);
    --cor-cta-fundo: var(--cor-primaria); 
    --cor-cta-texto: #1a1f25; /* Texto bem escuro */
    --cor-cta-hover-fundo: var(--cor-secundaria);

    --cor-highlight-item-fundo: var(--cor-fundo-secundario);
    --cor-feature-pair-titulo: var(--cor-primaria);
  }

  html { scroll-behavior: smooth; }

  body {
    margin: 0; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: var(--cor-fundo-primario); color: var(--cor-texto-primario);
    line-height: 1.6; overflow-x: hidden;
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  .container { width: 90%; max-width: 1100px; margin: 0 auto; padding: 20px 0; }

  h1, h2, h3, h4 { color: var(--cor-primaria); transition: color 0.3s ease; }
  /* Override para títulos em seções escuras no tema claro (ex: Footer H4) */
  .app-footer h4 { color: var(--cor-footer-titulo); }


  button {
    background-color: var(--cor-primaria); color: var(--cor-texto-claro);
    border: none; padding: 10px 20px; border-radius: 5px; cursor: pointer;
    font-size: 1rem; transition: background-color 0.3s ease, color 0.3s ease, transform 0.1s ease;
  }
  button:hover { background-color: var(--cor-acentuacao); transform: translateY(-1px); }
  button:active { transform: translateY(0px); }

  img { max-width: 100%; height: auto; display: block; }
  a { text-decoration: none; color: var(--cor-acentuacao); transition: color 0.3s ease; }
  a:hover { color: var(--cor-primaria); }
  body.dark-theme a:hover { color: var(--cor-secundaria); }


  /* --- Header Styles --- */
  .app-header {
    background-color: var(--cor-header-fundo); padding: 10px 0; 
    box-shadow: 0 2px 4px var(--cor-sombra); position: sticky; top: 0; z-index: 1000;
    transition: background-color 0.3s ease;
  }
  .header-container { display: flex; justify-content: space-between; align-items: center; }
  .logo-container { display: flex; align-items: center; }
  .logo { height: 50px; margin-right: 15px; }
  .app-name-header { font-size: 1.5rem; font-weight: bold; color: var(--cor-header-texto); transition: color 0.3s ease; }
  .header-right-content { display: flex; align-items: center; gap: 25px;  }
  .main-nav { display: flex; align-items: center; }
  .main-nav a {
    color: var(--cor-header-texto); margin-left: 20px; font-weight: bold; 
    transition: color 0.3s ease, border-color 0.3s ease; 
    padding-bottom: 3px; border-bottom: 2px solid transparent;
  }
  .main-nav a:first-child { margin-left: 0; }
  .main-nav a:hover { color: var(--cor-header-texto); filter: brightness(1.3); border-bottom-color: var(--cor-header-icone); }
  
  .header-controls { display: flex; align-items: center; gap: 15px; }
  .lang-switcher button { background: none; border: none; cursor: pointer; padding: 5px; opacity: 0.8; line-height: 0; margin: 0 3px; transition: opacity 0.3s ease; }
  .lang-switcher button.active { opacity: 1; transform: scale(1.1); }
  .lang-switcher button:hover { opacity: 1; }
  .flag-icon { width: 28px; height: auto; vertical-align: middle; border: 1px solid var(--cor-borda); border-radius: 3px; transition: border-color 0.3s ease; }
  .theme-toggle-button { background: none; border: none; color: var(--cor-header-icone); cursor: pointer; font-size: 1.5rem; padding: 5px; display: flex; align-items: center; justify-content: center; opacity: 0.9; transition: opacity 0.3s ease, color 0.3s ease, transform 0.2s ease; }
  .theme-toggle-button:hover { opacity: 1; transform: rotate(15deg); }

  /* --- Hero Styles --- */
  .hero-section {
    background: linear-gradient(135deg, var(--cor-primaria) 0%, var(--cor-secundaria) 100%); 
    color: var(--cor-hero-titulo); text-align: center; padding: 80px 20px; min-height: 60vh;
    display: flex; flex-direction: column; align-items: center; justify-content: center;
  }
  .hero-content h1 { color: var(--cor-hero-titulo); font-size: 2.8rem; margin-bottom: 15px; } 
  .hero-content h2 { color: var(--cor-hero-subtitulo); font-size: 1.5rem; margin-bottom: 25px; font-weight: 400; transition: color 0.3s ease; }
  .hero-content p { font-size: 1.1rem; max-width: 700px; margin: 0 auto 30px auto; }
  .cta-button {
    background-color: var(--cor-cta-fundo); color: var(--cor-cta-texto);
    padding: 12px 25px; font-size: 1.1rem; border-radius: 25px; font-weight: bold;
    transition: background-color 0.3s ease, color 0.3s ease, box-shadow 0.2s ease;
    box-shadow: 0 4px 8px var(--cor-sombra);
  }
  .cta-button:hover { background-color: var(--cor-cta-hover-fundo); box-shadow: 0 6px 12px var(--cor-sombra); }

  /* --- About App Section --- */
  .about-app-section { padding: 60px 0; background-color: var(--cor-fundo-primario); overflow: hidden; }
  .about-app-section .section-intro-title { /* ... */ }
  .about-app-section .section-intro-desc { color: var(--cor-texto-secundario); /* ... */ }
  .app-feature-pair { display: flex; align-items: center; gap: 40px; margin-bottom: 70px;  }
  .app-feature-pair:nth-child(odd) {  flex-direction: row-reverse; }
  .app-feature-pair-text, .app-feature-pair-image { flex: 1; min-width: 0; }
  .app-feature-pair-text h3 { font-size: 1.8rem;  margin-bottom: 15px; color: var(--cor-feature-pair-titulo);  }
  .app-feature-pair-text p { font-size: 1rem; line-height: 1.7; color: var(--cor-texto-secundario); }
  .app-feature-pair-image img { border-radius: 10px; box-shadow: 0 8px 25px var(--cor-sombra); }

  /* Animação de "aparecer" */
  .fade-in-left, .fade-in-right, .fade-in-up { opacity: 0; transition: opacity 0.8s ease-out, transform 0.8s ease-out; }
  .fade-in-left { transform: translateX(-50px); }
  .fade-in-right { transform: translateX(50px); }
  .fade-in-up { transform: translateY(40px); } 
  .is-visible { opacity: 1; transform: translate(0, 0); }

  /* --- Highlights Section --- */
  .highlights-section { padding: 50px 0; background-color: var(--cor-fundo-secundario); text-align: center;  }
  .highlights-section h2 { /* ... */ }
  .highlights-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 30px; }
  .highlight-item { 
    background-color: var(--cor-highlight-item-fundo); 
    padding: 30px 25px; border-radius: 8px; 
    box-shadow: 0 4px 12px var(--cor-sombra); text-align: center; 
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
   .highlight-item:hover { transform: translateY(-5px); box-shadow: 0 8px 16px var(--cor-sombra); }
  .highlight-item .highlight-icon { font-size: 2.8rem; display: block; margin-bottom: 20px; color: var(--cor-primaria); }
  .highlight-item h3 { /* Cor herdada e ajustada pelo tema */ }
  .highlight-item p { color: var(--cor-texto-secundario); }

  /* --- AppScreenshots Styles --- */
  .app-screenshots-section { padding: 50px 0; text-align: center; background-color: var(--cor-fundo-primario); }
  .app-screenshots-section h2 { /* ... */ }
  .screenshots-gallery { 
    display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); 
    gap: 20px; justify-items: center; 
  }
  .app-screenshot { 
    width: 100%; max-width: 250px; border-radius: 10px; 
    box-shadow: 0 5px 15px var(--cor-sombra); transition: transform 0.3s ease; 
  }
  .app-screenshot:hover { transform: scale(1.05); }

  /* --- Footer Styles --- */
  .app-footer { 
    background-color: var(--cor-footer-fundo); color: var(--cor-footer-texto); 
    padding: 40px 0 20px 0; transition: background-color 0.3s ease, color 0.3s ease;
  }
  .footer-content { 
    display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); 
    gap: 40px; /* Aumentar gap para mais respiro */ margin-bottom: 30px; 
  }
  .footer-column h4 { 
    color: var(--cor-footer-titulo); /* Usar variável específica */
    margin-bottom: 15px; font-size: 1.2rem; 
    transition: color 0.3s ease;
  }
  .footer-column p, .footer-column li { margin-bottom: 10px; font-size: 0.9rem; line-height: 1.5; }
  .footer-column a { 
    color: var(--cor-footer-texto); 
    text-decoration: none; /* Garantir que não tem sublinhado */
  }
  .footer-column a:hover { 
    color: var(--cor-footer-link-hover); 
    text-decoration: underline; /* Adicionar sublinhado no hover */
  }
  .footer-column ul { list-style: none; padding: 0; margin: 0; } /* Reset ul */
  .social-links { margin-top: 15px; /* Espaço acima dos links sociais */}
  .social-links a { 
    margin: 0 8px; /* Espaço horizontal entre links sociais */
    display: inline-block; 
    font-size: 1.1rem;
  }
  /* Ajuste para centralizar social links no mobile se text-align:center do pai não for suficiente */
  @media (max-width: 768px) {
     .social-links { text-align: center; } 
  }

  .footer-bottom { 
    text-align: center; padding-top: 20px; 
    border-top: 1px solid var(--cor-borda); 
    font-size: 0.9rem; transition: border-color 0.3s ease;
    color: var(--cor-texto-secundario); /* Cor mais suave para direitos autorais */
  }
  body.dark-theme .footer-bottom {
      color: var(--cor-texto-secundario); /* Manter cor suave */
  }


  /* --- Responsividade --- */
  @media (max-width: 768px) {
    .header-container { flex-direction: column; gap: 15px; }
    .header-right-content { flex-direction: column; gap: 15px; width: 100%; align-items: center; }
    .main-nav { justify-content: center; width: 100%; }
    .main-nav a { margin: 0 10px; }
    .header-controls { justify-content: center; }
    
    .hero-content h1 { font-size: 2.2rem; }
    .hero-content h2 { font-size: 1.3rem; }

    .app-feature-pair, .app-feature-pair:nth-child(odd) { 
      flex-direction: column; gap: 30px; margin-bottom: 50px;
    }
    .screenshots-gallery { grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); }
    .footer-content { grid-template-columns: 1fr; text-align: center; }
    .footer-column { margin-bottom: 20px; } 
    .footer-column ul { /* Garante que a lista centralize no mobile */
        display: inline-block;
        text-align: left; /* Alinha o texto dos itens à esquerda dentro da lista */
    }
  }
`;

// --- Hook para Intersection Observer ---
const useIntersectionObserver = (options) => {
  const [entry, setEntry] = useState(null);
  const [node, setNode] = useState(null);
  const observer = useRef(null);

  useEffect(() => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(([entry]) => { setEntry(entry); }, options);
    const { current: currentObserver } = observer;
    if (node) currentObserver.observe(node);
    return () => currentObserver.disconnect();
  }, [node, options]);

  return [setNode, entry];
};


// --- Componente para cada par de Feature (Informação/Imagem) ---
const FeaturePair = ({ feature, imageSrc, index, texts }) => {
  const isTextLeftForAnimation = index % 2 === 0; 
  const [refText, entryText] = useIntersectionObserver({ threshold: 0.2 });
  const [refImage, entryImage] = useIntersectionObserver({ threshold: 0.2, delay: isTextLeftForAnimation ? 100 : 0 });
  const textAnimationClass = isTextLeftForAnimation ? 'fade-in-left' : 'fade-in-right';
  const imageAnimationClass = isTextLeftForAnimation ? 'fade-in-right' : 'fade-in-left';

  return (
    <div className="app-feature-pair">
      <div ref={refText} className={`app-feature-pair-text ${textAnimationClass} ${entryText?.isIntersecting ? 'is-visible' : ''}`}>
        <h3>{feature.title}</h3>
        <p>{feature.description}</p>
      </div>
      <div ref={refImage} className={`app-feature-pair-image ${imageAnimationClass} ${entryImage?.isIntersecting ? 'is-visible' : ''}`}>
        <img src={imageSrc} alt={feature.imageAlt || `${texts.appName} - ${feature.title}`} />
      </div>
    </div>
  );
};


// --- Componentes Principais ---
const Header = ({ texts, currentLang, onLangChange, currentTheme, onThemeToggle }) => {
  const flagUrls = { pt: 'https://flagcdn.com/w40/mz.png', en: 'https://flagcdn.com/w40/gb.png' };
  return (
    <header className="app-header">
      <div className="container header-container">
        <div className="logo-container">
          <img src={logoSrc} alt={`${texts.appName} Logo`} className="logo" />
          <span className="app-name-header">{texts.appName}</span>
        </div>
        <div className="header-right-content">
          <nav className="main-nav">
            <a href="#inicio">{texts.navHome}</a>
            <a href="#funcionalidades">{texts.navAbout}</a>
            <a href="#contato">{texts.navContact}</a>
          </nav>
          <div className="header-controls">
            <div className="lang-switcher">
              <button onClick={() => onLangChange('pt')} className={currentLang === 'pt' ? 'active' : ''} title="Português">
                <img src={flagUrls.pt} alt="Bandeira de Moçambique" className="flag-icon" />
              </button>
              <button onClick={() => onLangChange('en')} className={currentLang === 'en' ? 'active' : ''} title="English">
                <img src={flagUrls.en} alt="United Kingdom Flag" className="flag-icon" />
              </button>
            </div>
            <button
              onClick={onThemeToggle}
              className="theme-toggle-button"
              aria-label={currentTheme === 'light' ? texts.themeToggleDark : texts.themeToggleLight}
              title={currentTheme === 'light' ? texts.themeToggleDark : texts.themeToggleLight}
            >
              {currentTheme === 'light' ? '🌙' : '☀️'}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

const Hero = ({ texts }) => { 
  return (
    <section id="inicio" className="hero-section">
      <div className="container hero-content">
        <h1>{texts.heroTitle}</h1>
        <h2>{texts.heroSubtitle}</h2>
        <p>{texts.heroDescription}</p>
        <button className="cta-button" onClick={() => window.location.href = "https://projectoescola-4n9k6tlir-constantino-mahengas-projects.vercel.app/"}>{texts.heroButton}</button>
      </div>
    </section>
  );
};

const AboutAppSection = ({ texts }) => {
  const images = [appScreen1, appScreen2, appScreen3, appScreen4, appScreen5];
  const [refTitle, entryTitle] = useIntersectionObserver({ threshold: 0.2 });
  const [refDesc, entryDesc] = useIntersectionObserver({ threshold: 0.2, delay: 100 });

  return (
    <section id="funcionalidades" className="about-app-section"> 
      <div className="container">
        <h2 ref={refTitle} className={`section-intro-title fade-in-up ${entryTitle?.isIntersecting ? 'is-visible' : ''}`}>
            {texts.aboutAppTitle}
        </h2>
        <p ref={refDesc} className={`section-intro-desc fade-in-up ${entryDesc?.isIntersecting ? 'is-visible' : ''}`}>
            {texts.aboutAppDescription}
        </p>
        {texts.appFeatures.map((feature, index) => (
          <FeaturePair
            key={index}
            feature={feature}
            imageSrc={images[index % images.length]} 
            index={index}
            texts={texts}
          />
        ))}
      </div>
    </section>
  );
};

const HighlightsSection = ({ texts }) => {
  const icons = ["⚙️", "📊", "💬"]; 
  return (
    <section className="highlights-section">
      <div className="container">
        <h2>{texts.highlightsTitle}</h2>
        <div className="highlights-grid">
          <div className="highlight-item">
            <span className="highlight-icon">{icons[0]}</span>
            <h3>{texts.highlight1Title}</h3>
            <p>{texts.highlight1Desc}</p>
          </div>
          <div className="highlight-item">
            <span className="highlight-icon">{icons[1]}</span>
            <h3>{texts.highlight2Title}</h3>
            <p>{texts.highlight2Desc}</p>
          </div>
          <div className="highlight-item">
            <span className="highlight-icon">{icons[2]}</span>
            <h3>{texts.highlight3Title}</h3>
            <p>{texts.highlight3Desc}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

const AppScreenshots = ({ texts }) => {
  const images = [appScreen1, appScreen2, appScreen3, appScreen4, appScreen5];
  return (
    <section className="app-screenshots-section">
      <div className="container">
        <h2>{texts.screenshotsTitle}</h2>
        <div className="screenshots-gallery">
          {images.map((imgSrc, index) => (
            <img
              key={index}
              src={imgSrc}
              alt={`${texts.appName} - Screenshot ${index + 1}`}
              className="app-screenshot"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const Footer = ({ texts }) => { 
  const currentYear = new Date().getFullYear();
  // PREENCHA ESTES DADOS
  const empresaNome = "EduTech Solutions"; 
  
  const empresaEndereco = "Ponta-Gêa, Beira - Moçambique"; 
  const contatoEmail = "Email: comercial@ralteclab.com";
  const contatoTelefone = "+258 84 64 24 083"; 
  const contatoSite = "https://www.ralteclab.com"; 

  const footerRightsText = texts.footerRights
     .replace("{currentYear}", currentYear.toString())
     .replace("{appName}", texts.appName);

  return (
    <footer id="contato" className="app-footer">
      <div className="container footer-content">
        <div className="footer-column">
          <h4>{texts.footerAboutCompany.replace("{empresaNome}", empresaNome)}</h4>
          <p>{texts.footerCompanyDesc}</p>
      
          <p><strong>{texts.footerAddress}:</strong> {empresaEndereco}</p>
        </div>
        <div className="footer-column">
          <h4>{texts.footerContact}</h4>
          <p><strong>{texts.footerEmail}:</strong> <a href={`mailto:${contatoEmail}`}>{contatoEmail}</a></p>
          <p><strong>{texts.footerPhone}:</strong> <a href={`tel:${contatoTelefone.replace(/\D/g, '')}`}>{contatoTelefone}</a></p>
           {contatoSite && <p><strong>Site:</strong> <a href={contatoSite} target="_blank" rel="noopener noreferrer">{contatoSite}</a></p>}
           <div className="social-links">
             {/* Adicione links de redes sociais aqui se tiver, ex: Facebook, LinkedIn */}
             {/* <a href="LINK_FACEBOOK" target="_blank" rel="noopener noreferrer" title="Facebook">FB</a> */}
           </div>
        </div>
        <div className="footer-column">
          <h4>{texts.footerNavigation}</h4>
          <ul>
            <li><a href="#inicio">{texts.navHome}</a></li>
            <li><a href="#funcionalidades">{texts.navAbout}</a></li>
            <li><a href="#">{texts.footerPrivacy}</a></li>
            <li><a href="#">{texts.footerTerms}</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>{footerRightsText}</p>
      </div>
    </footer>
  );
};

// --- Componente Principal App ---
function App() {
  const [language, setLanguage] = useState('pt');
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      const localTheme = localStorage.getItem('edugest-theme'); 
      return localTheme || 'light';
    }
    return 'light'; 
  });

  const handleLanguageChange = (lang) => { setLanguage(lang); };

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    if (typeof window !== 'undefined') {
      localStorage.setItem('edugest-theme', newTheme); 
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      document.body.className = ''; 
      document.body.classList.add(theme + '-theme');
    }
  }, [theme]);

  const currentTexts = translations[language];

  return (
    <>
      <style>{GlobalStyles}</style>
      <Header
        texts={currentTexts}
        currentLang={language}
        onLangChange={handleLanguageChange}
        currentTheme={theme}
        onThemeToggle={toggleTheme}
      />
      <main>
        <Hero texts={currentTexts} />
        <AboutAppSection texts={currentTexts} />
        <HighlightsSection texts={currentTexts} />
        <AppScreenshots texts={currentTexts} />
      </main>
      <Footer texts={currentTexts} />
    </>
  );
}

export default App;